module.exports = __webpack_public_path__ + "images/category_lp/common/reason2-jewel_e28f2e583f995f0ff9871ad0ecbecc1d.jpg";